import type { SVGProps } from 'react';

export const MusicIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9493 1.93853L8.61598 3.49453C7.48665 3.68253 6.66665 4.65053 6.66665 5.79586V15.0852C6.16398 14.8265 5.60265 14.6665 4.99999 14.6665C2.97732 14.6665 1.33333 16.3105 1.33333 18.3332C1.33333 20.3558 2.97732 21.9998 4.99999 21.9998C7.02265 21.9998 8.66664 20.3558 8.66664 18.3332V9.84651L18.6666 8.17985V13.0852C18.164 12.8265 17.6026 12.6665 17 12.6665C14.9773 12.6665 13.3333 14.3105 13.3333 16.3332C13.3333 18.3558 14.9773 19.9998 17 19.9998C19.0226 19.9998 20.6666 18.3558 20.6666 16.3332V4.2412C20.6666 3.5532 20.3653 2.9052 19.8413 2.4612C19.3159 2.0172 18.6306 1.82787 17.9493 1.93987V1.93853Z"
      fill="currentColor"
    />
  </svg>
);
